// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-modal__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
  box-sizing: border-box;
}

.product-modal__content {
  position: relative;
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  overflow-y: auto;
  background: #ffffff;
  border: 2px solid #a78c83;
  border-radius: 32px;
  padding: 24px;
  box-sizing: border-box;
  box-shadow: 0 8px 32px rgba(78, 63, 58, 0.2);
}

.product-modal__close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #4e3f3a;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-modal__close::before,
.product-modal__close::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 2px;
  border-radius: 2px;
  background: #fff;
}

.product-modal__close::before {
  transform: rotate(45deg);
}

.product-modal__close::after {
  transform: rotate(-45deg);
}

.product-modal__close:hover {
  background: #5c4a44;
}

.product-modal__body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.product-modal__image {
  width: 100%;
  height: 220px;
  border-radius: 20px;
  border: 1px solid #a78c83;
  background-color: #e8e4df;
  background-size: cover;
  background-position: center;
  flex-shrink: 0;
}

.product-modal__info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.product-modal__combo-label {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #2d6a4f;
}

.product-modal__title {
  margin: 0;
  padding-right: 48px;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 22px;
  line-height: 1.3;
  color: #4e3f3a;
}

.product-modal__combo-items {
  margin: 4px 0 0 18px;
  padding: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  line-height: 1.45;
  color: #4e3f3a;
}

.product-modal__description {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 15px;
  line-height: 1.5;
  color: #4e3f3a;
}

.product-modal__ingredients {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  line-height: 1.4;
  color: #4e3f3a;
  opacity: 0.9;
}

.product-modal__bju {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 4px 16px;
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #4e3f3a;
}

.product-modal__bju dt {
  margin: 0;
  font-weight: 500;
}

.product-modal__bju dd {
  margin: 0;
}

.product-modal__grams {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #4e3f3a;
  opacity: 0.8;
}

.product-modal__bonus {
  margin: 6px 0 0 0;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #8a6d3b;
}

.product-modal__price {
  margin: 8px 0 0 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #4e3f3a;
}

.product-modal__modifiers {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-modal__modifiers-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #4e3f3a;
}

.product-modal__modifier-row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 8px;
  align-items: center;
  font-size: 14px;
  color: #4e3f3a;
}

.product-modal__add-btn {
  margin-top: 8px;
  width: 100%;
  height: 44px;
  background: #ff9702;
  border: 2px solid #a78c83;
  border-radius: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #4e3f3a;
  cursor: pointer;
}

.product-modal__add-btn:hover:not(:disabled) {
  opacity: 0.95;
}

.product-modal__add-btn:disabled {
  background: #e0d8d3;
  color: #7a6d68;
  cursor: not-allowed;
}

.product-modal__unavailable {
  margin: 8px 0 0;
  padding: 8px 10px;
  background: #fdecea;
  border: 1px solid #f5c6c8;
  color: #b32129;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.35;
}

@media (min-width: 520px) {
  .product-modal__body {
    flex-direction: row;
  }

  .product-modal__image {
    width: 220px;
    height: 220px;
    flex-shrink: 0;
  }

  .product-modal__info {
    flex: 1;
    min-width: 0;
  }
}

@media (max-width: 768px) {
  .product-modal__backdrop {
    padding: 14px;
  }

  .product-modal__content {
    max-width: none;
    max-height: calc(100vh - 28px);
    border-radius: 22px;
    padding: 14px;
  }

  .product-modal__title {
    padding-right: 36px;
    font-size: 20px;
  }

  .product-modal__body {
    gap: 14px;
  }

  .product-modal__image {
    height: 184px;
    border-radius: 14px;
  }
}

@media (max-width: 430px) {
  .product-modal__backdrop {
    padding: 8px;
  }

  .product-modal__content {
    max-height: calc(100vh - 16px);
    border-radius: 16px;
    border-width: 1px;
    padding: 12px;
  }

  .product-modal__close {
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
  }

  .product-modal__title {
    font-size: 18px;
    padding-right: 30px;
  }

  .product-modal__description,
  .product-modal__ingredients,
  .product-modal__bju,
  .product-modal__grams {
    font-size: 13px;
  }

  .product-modal__price {
    font-size: 20px;
    line-height: 1.2;
  }

  .product-modal__add-btn {
    height: 40px;
    border-radius: 14px;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,OAAO;IACP,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":[".product-modal__backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n.product-modal__content {\n  position: relative;\n  width: 100%;\n  max-width: 560px;\n  max-height: 90vh;\n  overflow-y: auto;\n  background: #ffffff;\n  border: 2px solid #a78c83;\n  border-radius: 32px;\n  padding: 24px;\n  box-sizing: border-box;\n  box-shadow: 0 8px 32px rgba(78, 63, 58, 0.2);\n}\n\n.product-modal__close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: #4e3f3a;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.product-modal__close::before,\n.product-modal__close::after {\n  content: '';\n  position: absolute;\n  width: 16px;\n  height: 2px;\n  border-radius: 2px;\n  background: #fff;\n}\n\n.product-modal__close::before {\n  transform: rotate(45deg);\n}\n\n.product-modal__close::after {\n  transform: rotate(-45deg);\n}\n\n.product-modal__close:hover {\n  background: #5c4a44;\n}\n\n.product-modal__body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.product-modal__image {\n  width: 100%;\n  height: 220px;\n  border-radius: 20px;\n  border: 1px solid #a78c83;\n  background-color: #e8e4df;\n  background-size: cover;\n  background-position: center;\n  flex-shrink: 0;\n}\n\n.product-modal__info {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.product-modal__combo-label {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #2d6a4f;\n}\n\n.product-modal__title {\n  margin: 0;\n  padding-right: 48px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 1.3;\n  color: #4e3f3a;\n}\n\n.product-modal__combo-items {\n  margin: 4px 0 0 18px;\n  padding: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 14px;\n  line-height: 1.45;\n  color: #4e3f3a;\n}\n\n.product-modal__description {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 15px;\n  line-height: 1.5;\n  color: #4e3f3a;\n}\n\n.product-modal__ingredients {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #4e3f3a;\n  opacity: 0.9;\n}\n\n.product-modal__bju {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 4px 16px;\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 14px;\n  color: #4e3f3a;\n}\n\n.product-modal__bju dt {\n  margin: 0;\n  font-weight: 500;\n}\n\n.product-modal__bju dd {\n  margin: 0;\n}\n\n.product-modal__grams {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 14px;\n  color: #4e3f3a;\n  opacity: 0.8;\n}\n\n.product-modal__bonus {\n  margin: 6px 0 0 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 14px;\n  color: #8a6d3b;\n}\n\n.product-modal__price {\n  margin: 8px 0 0 0;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 28px;\n  color: #4e3f3a;\n}\n\n.product-modal__modifiers {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.product-modal__modifiers-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #4e3f3a;\n}\n\n.product-modal__modifier-row {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 8px;\n  align-items: center;\n  font-size: 14px;\n  color: #4e3f3a;\n}\n\n.product-modal__add-btn {\n  margin-top: 8px;\n  width: 100%;\n  height: 44px;\n  background: #ff9702;\n  border: 2px solid #a78c83;\n  border-radius: 18px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 21px;\n  color: #4e3f3a;\n  cursor: pointer;\n}\n\n.product-modal__add-btn:hover:not(:disabled) {\n  opacity: 0.95;\n}\n\n.product-modal__add-btn:disabled {\n  background: #e0d8d3;\n  color: #7a6d68;\n  cursor: not-allowed;\n}\n\n.product-modal__unavailable {\n  margin: 8px 0 0;\n  padding: 8px 10px;\n  background: #fdecea;\n  border: 1px solid #f5c6c8;\n  color: #b32129;\n  border-radius: 8px;\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n@media (min-width: 520px) {\n  .product-modal__body {\n    flex-direction: row;\n  }\n\n  .product-modal__image {\n    width: 220px;\n    height: 220px;\n    flex-shrink: 0;\n  }\n\n  .product-modal__info {\n    flex: 1;\n    min-width: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .product-modal__backdrop {\n    padding: 14px;\n  }\n\n  .product-modal__content {\n    max-width: none;\n    max-height: calc(100vh - 28px);\n    border-radius: 22px;\n    padding: 14px;\n  }\n\n  .product-modal__title {\n    padding-right: 36px;\n    font-size: 20px;\n  }\n\n  .product-modal__body {\n    gap: 14px;\n  }\n\n  .product-modal__image {\n    height: 184px;\n    border-radius: 14px;\n  }\n}\n\n@media (max-width: 430px) {\n  .product-modal__backdrop {\n    padding: 8px;\n  }\n\n  .product-modal__content {\n    max-height: calc(100vh - 16px);\n    border-radius: 16px;\n    border-width: 1px;\n    padding: 12px;\n  }\n\n  .product-modal__close {\n    top: 10px;\n    right: 10px;\n    width: 30px;\n    height: 30px;\n  }\n\n  .product-modal__title {\n    font-size: 18px;\n    padding-right: 30px;\n  }\n\n  .product-modal__description,\n  .product-modal__ingredients,\n  .product-modal__bju,\n  .product-modal__grams {\n    font-size: 13px;\n  }\n\n  .product-modal__price {\n    font-size: 20px;\n    line-height: 1.2;\n  }\n\n  .product-modal__add-btn {\n    height: 40px;\n    border-radius: 14px;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
